module.exports = __webpack_public_path__ + "static/critical-danger-f07214819275976146ec3c811f338e4c.png";